import ImagesIconsArrowDownGreySvg from '@/public/images/icons/arrow_down_grey.svg';
import ImagesIconsArrowRightSvg from '@/public/images/icons/arrow_right.svg';
import ImagesIconsArrowUpGreenSvg from '@/public/images/icons/arrow-up-green.svg';
import ImagesIconsAuthBySpititorySvg from '@/public/images/icons/auth-by-spititory.svg';
import ImagesIconsBellSvg from '@/public/images/icons/bell.svg';
import ImagesIconsBottleSizeSvg from '@/public/images/icons/bottle-size.svg';
import ImagesIconsBuyerProtectionSvg from '@/public/images/icons/buyer-protection.svg';
import ImagesIconsDotsSvg from '@/public/images/icons/dots.svg';
import ImagesIconsDownloadSvg from '@/public/images/icons/download.svg';
import ImagesIconsFilterSvg from '@/public/images/icons/filter.svg';
import ImagesIconsFilterWhiteSvg from '@/public/images/icons/filterWhite.svg';
import ImagesIconsHeartFilledSvg from '@/public/images/icons/heart-filled.svg';
import ImagesIconsHeartSvg from '@/public/images/icons/heart.svg';
import ImagesIconsHomeSvg from '@/public/images/icons/home.svg';
import ImagesIconsPlusSvg from '@/public/images/icons/plus.svg';
import ImagesIconsPortfolioLogoSvg from '@/public/images/icons/portfolio_logo.svg';
import ImagesIconsPriceTagSvg from '@/public/images/icons/price-tag.svg';
import ImagesIconsSandwatchSvg from '@/public/images/icons/sandwatch.svg';
import ImagesIconsSearchSvg from '@/public/images/icons/search.svg';
import ImagesIconsShareSvg from '@/public/images/icons/share.svg';
import ImagesIconsSortSvg from '@/public/images/icons/sort.svg';
import ImagesIconsUserSvg from '@/public/images/icons/user.svg';
import ImagesIconsVerifyEmailSvg from '@/public/images/icons/verify-email.svg';
import ImagesIconsWishlistHeaderSvg from '@/public/images/icons/wishlist_header.svg';

export {
  ImagesIconsArrowDownGreySvg,
  ImagesIconsArrowRightSvg,
  ImagesIconsArrowUpGreenSvg,
  ImagesIconsAuthBySpititorySvg,
  ImagesIconsBellSvg,
  ImagesIconsBottleSizeSvg,
  ImagesIconsBuyerProtectionSvg,
  ImagesIconsDotsSvg,
  ImagesIconsDownloadSvg,
  ImagesIconsFilterSvg,
  ImagesIconsFilterWhiteSvg,
  ImagesIconsHeartFilledSvg,
  ImagesIconsHeartSvg,
  ImagesIconsHomeSvg,
  ImagesIconsPlusSvg,
  ImagesIconsPortfolioLogoSvg,
  ImagesIconsPriceTagSvg,
  ImagesIconsSandwatchSvg,
  ImagesIconsSearchSvg,
  ImagesIconsShareSvg,
  ImagesIconsSortSvg,
  ImagesIconsUserSvg,
  ImagesIconsVerifyEmailSvg,
  ImagesIconsWishlistHeaderSvg,
};
